<template>
  <div>
    <b-row v-if="showFilters" class="pt-2 pb-1">
      <b-col cols="6">
        <BreadcrumbMenu />
      </b-col>
    </b-row>

    <b-card class="m-2" no-body>
      <b-row class="m-2">
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label class="text-capitalize">{{ $t("table.show") }}</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
          />
          <label class="text-capitalize">{{ $t("table.entries") }}</label>
        </b-col>
      </b-row>
      <b-table
        ref="refListTable"
        :items="fetchList"
        :fields="tableColumns"
        responsive
        show-empty
        empty-text="No se encontraron empleados"
      >
        <template #cell(active)="data">
          <feather-icon
            v-if="data.item.active"
            class="text-success"
            icon="CheckCircleIcon"
            size="14"
          />
          <feather-icon
            v-else
            class="text-danger"
            icon="XCircleIcon"
            size="14"
          />
        </template>
      </b-table>
      <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted text-capitalize">{{
            $t("table.showing", {
              from: dataMeta.from,
              to: dataMeta.to,
              of: dataMeta.of,
            })
          }}</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <Pagination
            data-cy="pagination"
            :totalList="totalList"
            :currentPage="currentPage"
            @updatePagination="update"
            :perPage="perPage"
          >
          </Pagination>
        </b-col>
      </b-row>
    </div>
    </b-card>
  </div>
</template>

<script>
import { onMounted,onUnmounted } from '@vue/composition-api';
import useList from "./useList";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import Pagination from "@/components/Pagination.vue";
import vSelect from "vue-select";

export default {
  components: {
    BreadcrumbMenu,
    Pagination,
    vSelect
  },
  props: {
    showFilters: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    //HOOKS
    onMounted(() => connectSocket());

    onUnmounted(() => {
      window.Echo.leave('shift-session-user-check');
    });

    //COMPOSABLES
    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
    } = useList();

    //METHODS
    const connectSocket = () => {
      window.Echo.private('shift-session-user-check')
        .listen('.shift-session-user', () => refetchData());
    }
    const update = (data) => {
      currentPage.value = data;
    }

    return {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,

      update
    }
  }
}
</script>
